// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@bg/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { xScreen } from "@bg/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.headerGridContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }

        button {
            span {
                color: ${getColor("text.main")} !important;
            }
            svg {
                fill: ${getColor("tertiary.main")} !important;
            }
        }
    `,
};
